import { InfoIcon } from 'BreetAssets';
import { Tooltip, TooltipContent } from 'BreetComponents';
import { memo } from 'react';

import type { IFiatInputLabelProps } from '../FiatInput.helpers';

export const FiatInputLabel = memo(({ id, label, tooltip }: IFiatInputLabelProps) => (
	<label
		className='fiat_input_label color-neutral-50'
		htmlFor={id}
	>
		{label}

		{tooltip && (
			<Tooltip
				tipElement={<TooltipContent content={tooltip} />}
				unclipped
			>
				<InfoIcon
					className='info-icon svg-dark'
					variant='square-dark'
				/>
			</Tooltip>
		)}
	</label>
));

FiatInputLabel.displayName = 'FiatInputLabel';
